import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import FormWrapper from '../../../common/form/FormWrapper';
import Form from '../../../common/form/Form';
import FormField from '../../../common/form/FormField';


class UpdateNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submission: false,
      fields: {
        notes: props.community.notes || ''
      }
    };

    this.onFieldChange = this.onFieldChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { error } = this.props;
    const { error: prevError } = prevProps;

    if(error && error !== prevError) {
      this.setState({ submission: false });
    }
  }

  onFieldChange(event) {
    let { name, value } = event.target;
    let fields = { ...this.state.fields };
    fields[name] = value;
    this.setState({ fields });
  }

  onSubmit(event) {
    event.preventDefault();
    const self = this;
    this.setState({ submission: true }, () => {
      self.props.onSubmit(this.state.fields);
    });
  }

  render() {
    const { submission, fields } = this.state;
    const { onCancel } = this.props;
    
    return (
      <FormWrapper squared={true} raised={true}>
        <Form id='UpdateNotes-form' onSubmit={this.onSubmit} onClickSecondary={onCancel}
          submitLabel="Update" submission={submission} autoComplete="off">

            <FormField fieldName="notes">
              <TextField name="notes" placeholder="Notes" value={fields.notes} onChange={this.onFieldChange} multiline />
            </FormField>

        </Form>
      </FormWrapper>
    );
  }
}

UpdateNotes.propTypes = {
  community: PropTypes.object,
  error: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func
};

export default UpdateNotes;